import { useCallback, useSyncExternalStore } from 'react'

/**
 * True when the viewport is at least `minWidth`. Reports false during server
 * render and hydration, then the real value, so callers can mount a subtree on
 * one side of a breakpoint only.
 *
 * Reach for CSS first. This exists for the cases where hiding is not enough —
 * a component that fires analytics or fetches on mount still does so when it
 * is `display: none`.
 */
export function useMinWidth(minWidth: number): boolean {
    const query = `(min-width: ${minWidth}px)`

    const subscribe = useCallback(
        (onChange: () => void) => {
            if (typeof window === 'undefined') return () => {}
            const list = window.matchMedia(query)
            list.addEventListener('change', onChange)
            return () => list.removeEventListener('change', onChange)
        },
        [query],
    )

    const getSnapshot = useCallback(
        () => window.matchMedia(query).matches,
        [query],
    )

    return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
